import { fmtTime } from "@/components/dash/Ui";

const flag = (cc) => (cc ? cc.toUpperCase().replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0))) : "");

export const ClicksTable = ({ rows }) => (
  <div className="overflow-x-auto" data-testid="clicks-table">
    <table className="w-full text-sm">
      <thead>
        <tr className="text-left text-xs uppercase tracking-wider text-slate-500 border-b border-slate-800">
          <th className="py-3 pr-4 font-medium">Time</th>
          <th className="py-3 pr-4 font-medium">IP address</th>
          <th className="py-3 pr-4 font-medium">Location</th>
          <th className="py-3 pr-4 font-medium">Link</th>
          <th className="py-3 pr-4 font-medium">Number</th>
          <th className="py-3 pr-4 font-medium">Device</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((c) => (
          <tr key={c.id} data-testid="clicks-table-row" className="border-b border-slate-800/60 hover:bg-slate-800/30 transition-colors">
            <td className="py-3 pr-4 text-slate-400 whitespace-nowrap">{fmtTime(c.created_at)}</td>
            <td className="py-3 pr-4 font-mono text-emerald-300">{c.ip}</td>
            <td className="py-3 pr-4 whitespace-nowrap">
              {c.country ? `${flag(c.country_code)} ${[c.city, c.region, c.country].filter(Boolean).join(", ")}` : <span className="text-slate-500">Unknown</span>}
            </td>
            <td className="py-3 pr-4 font-mono text-slate-300">/{c.slug}</td>
            <td className="py-3 pr-4 whitespace-nowrap">{c.agent_name}{c.phone && <span className="block font-mono text-xs text-slate-500">+{c.phone}</span>}</td>
            <td className="py-3 pr-4 capitalize text-slate-400">{c.device}</td>
          </tr>
        ))}
      </tbody>
    </table>
    {!rows.length && <p className="text-center text-slate-500 py-10" data-testid="clicks-empty">No clicks yet</p>}
  </div>
);
